import { Box, Typography } from '@mui/material';
import { DAY_NAMES, MONTH_NAMES, buildDayCells, isToday, isSelected, toISODate } from '../Types/DatePickerHelpers';

/**
 * MiniMonthGrid — selectable month grid for CalEventDatePicker.
 * Clicking a day calls onSelect with the ISO date string.
 * @param {object} props
 * @param {number} props.year
 * @param {number} props.month - 0-based
 * @param {Date} props.today
 * @param {string} props.selectedDate - YYYY-MM-DD, or ''
 * @param {function} props.onSelect - fn(isoDate)
 */
export default function MiniMonthGrid({ year, month, today, selectedDate, onSelect }) {
    const cells = buildDayCells(year, month);

    return (
        <Box sx={{ minWidth: 196 }}>
            {/* Month + year header */}
            <Typography sx={{
                color: '#a3d1ff',
                fontSize: 12,
                fontWeight: 700,
                fontFamily: "'DM Sans', sans-serif",
                mb: '6px',
                textAlign: 'center',
                letterSpacing: '0.04em',
            }}>
                {MONTH_NAMES[month]} {year}
            </Typography>

            {/* Day name headers */}
            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', mb: '4px' }}>
                {DAY_NAMES.map((d) => (
                    <Typography key={d} sx={{
                        color: '#a3d1ff',
                        fontSize: 10,
                        fontFamily: "'DM Sans', sans-serif",
                        fontWeight: 600,
                        textAlign: 'center',
                    }}>
                        {d}
                    </Typography>
                ))}
            </Box>

            {/* Day cells */}
            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '2px' }}>
                {cells.map((d, i) => {
                    const today_ = isToday(d, year, month, today);
                    const selected_ = isSelected(d, year, month, selectedDate);
                    return (
                        <Box
                            key={i}
                            onClick={() => d !== null && onSelect(toISODate(year, month, d))}
                            sx={{
                                width: 24,
                                height: 24,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '4px',
                                cursor: d !== null ? 'pointer' : 'default',
                                bgcolor: selected_ ? '#66b2ff' : today_ ? '#0d3560' : 'transparent',
                                '&:hover': d !== null ? { bgcolor: selected_ ? '#66b2ff' : '#1a3a5c' } : {},
                            }}
                        >
                            {d !== null && (
                                <Typography sx={{
                                    fontSize: 11,
                                    fontFamily: "'DM Sans', sans-serif",
                                    fontWeight: selected_ || today_ ? 700 : 400,
                                    color: selected_ ? '#0b1e2e' : today_ ? '#a3d1ff' : '#b0c8e0',
                                    lineHeight: 1,
                                }}>
                                    {d}
                                </Typography>
                            )}
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
}
